<template>
	<div class="shared-stream-placeholder">
		<section class="action-section quick-start-section">
			<div>
				<FontAwesomeIcon
					class="icon"
					:icon="[ `fas`, `message-bot`, ]" />
			</div>
			<h1 class="title">{{ translate( `quickStartTitle` ) }}</h1>
			<div class="description" v-html="translate( `quickStartDescription` )"></div>
			<div class="actions">
				<TeamingButton2
					size="SMALL"
					type="SECONDARY"
					@click="$emit( `takeNotes` )"
				>
					{{ translate( `takeNotesButtonText` ) }}
				</TeamingButton2>
			</div>
		</section>
		<div class="divider-section">
			<div class="divider"></div>
			<div>{{ translate( `orLabel` ) }}</div>
			<div class="divider"></div>
		</div>
		<section class="action-section plan-ahead-section">
			<div>
				<FontAwesomeIcon
					class="icon"
					:icon="[ `fas`, `list`, ]" />
			</div>
			<h1 class="title">{{ translate( `planAheadTitle` ) }}</h1>
			<div class="description" v-html="translate( `planAheadDescription` )"></div>
			<div class="actions">
				<TeamingButton2
					size="SMALL"
					type="SECONDARY"
					@click="$emit( `scheduleMeeting` )"
				>
					{{ translate( `scheduleMeetingsText` ) }}
				</TeamingButton2>
			</div>
		</section>
	</div>
</template>

<script>
import {
	TranslateMixin,
	TeamingButton2
} from "@teaming/common-ui";

export default {
	name: "SharedStreamPlaceholder",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [
		"takeNotes",
		"scheduleMeeting",
	],
	components: {
		TeamingButton2,
	},
};
</script>

<style lang="scss" scoped>
$titleColor: $color2-500;
$textColor: $color1-700;
$backgroundColor: $white;

.shared-stream-placeholder {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 2rem;

	padding: 2rem;
	color: $textColor;
	background-color: $backgroundColor;
	border: 0.0625rem solid $borderColor--dark;
	border-radius: 0.5rem;

	@include for-size('md') {
		flex-direction: row;
	}

	> .action-section {
		flex: 1;

		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		gap: 1rem;
	}

	> .action-section .icon {
		color: $titleColor;
		@include font-and-line-for(5);
	}

	> .action-section .title {
		@include font-and-line-for(2);
		text-align: center;
		color: $titleColor;
	}

	> .action-section .description {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		gap: 1rem;

		@include font-and-line-for(0);
		text-align: center;

		@include for-size('sm') {
			max-width: 60%;
		}

		@include for-size('md') {
			max-width: 50%;
		}
	}

	> .action-section .actions {
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 1rem;

		@include for-size('sm') {
			flex-direction: row;
		}
	}

	> .divider-section {
		display: flex;
		flex-direction: row;
		justify-content: stretch;
		align-items: center;
		gap: 1rem;

		padding: 0 1rem;

		@include for-size('md') {
			flex-direction: column;
		}
	}

	> .divider-section .divider {
		flex: 1;

		background-color: $borderColor--dark;
		height: 1px;
		width: auto;

		@include for-size('md') {
			height: auto;
			width: 1px;
		}
	}
}
</style>
